import { ROUTES } from '@/constants/routes'

/** Shared Finance sub-nav — keep in sync across all Finance pages. */
export const FINANCE_TABS = [
  { label: 'Overview', path: ROUTES.FINANCE_OVERVIEW },
  { label: 'Cash flow', path: ROUTES.FINANCE_CASH_FLOW },
  { label: 'Invoices', path: ROUTES.FINANCE_INVOICES },
  { label: 'Purchases', path: ROUTES.FINANCE_PURCHASES },
  { label: 'Products & services', path: ROUTES.FINANCE_PRODUCTS_SERVICES },
  { label: 'Operational costs', path: ROUTES.FINANCE_OPERATIONAL_COSTS },
  { label: 'Business snapshot', path: ROUTES.FINANCE_SNAPSHOT },
  { label: 'Business analytics', path: ROUTES.FINANCE_ANALYTICS },
] as const
